import userClient from "../../services/httpClient/userClient";
import authClient from "../../services/httpClient/authClient";
import {
  BusinessDetailPayload,
  EmploymentDetailPayload,
  EmploymentDetailResponse,
  GetUserResponse,
  ReferralCodeResponse,
  UserUpdatePayload,
  UpdateUserResponse,
  BusinessDetailsResponse,
  ProfileImage,
  ProfileImageResponse,
  IdNumberConfirmationResponse,
  OtpValidatePayload,
  ValidateOtpResponse,
  // NewProfileImageResponse,
} from "./models";

export const getReferralCode = () =>
  userClient.get<ReferralCodeResponse>("/api/Customer/referral-code");

export const getEmploymentDetail = () =>
  userClient.get<EmploymentDetailResponse>("/api/Customer/employment-details");

export const updateEmploymentDetail = (payload: EmploymentDetailPayload) =>
  userClient.put<ReferralCodeResponse>("/api/Customer/employment-details", payload);

export const getUser = () => userClient.get<GetUserResponse>("/api/Customer");

export const updateUser = (payload: UserUpdatePayload) =>
  userClient.put<UpdateUserResponse>("/api/Customer", payload);

export const getBusinessDetails = () =>
  userClient.get<BusinessDetailsResponse>("/api/Customer/business-details");

export const updateBusinessDetails = (payload: BusinessDetailPayload) =>
  userClient.put<BusinessDetailsResponse>(
    "/api/Customer/business-details",
    payload
  );

export const uploadProfileImage = (payload: ProfileImage) =>
  userClient.post<ProfileImageResponse>(
    "/api/Customer/upload-profile-image",
    payload
  );
export const getProfileImage = () =>
  userClient.get<ProfileImageResponse>("/api/Customer/get-profile-image");

export const confirmUserIdentity = (idNumber: string, idType: number) =>
  userClient.get<IdNumberConfirmationResponse>(
    `/api/Customer/identity-verification?idNumber=${idNumber}&idType=${idType}`
  );

// export const otpSend = () => userClient.post('/api/Otp/send')

export const otpValidate = async (payload: OtpValidatePayload) =>
  authClient.post("/api/Account/validate-otp", payload);



// export const setUpSecurityQuestion = async (body: any) => authClient.post(
//   '/api/Account/savesecurity-questions',
//   body
// )